export default __webpack_public_path__ + "static/media/Linkedin.d9dc39fa.svg";